module.exports = __webpack_public_path__ + "static/media/1488.ce797770.gif";